/**
 * Created by brandonong on 23/12/17.
 */
import React, {Component} from 'react';
import './App.css';
import {Field, reduxForm, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import store from './store'
const selector = formValueSelector('fieldArrays');

class NumberofBox extends React.Component {


    render() {
        console.log(store.getState().form)
        const {numberofbox, differentaddress, reset} = this.props;
        const morethanonebox = parseFloat(numberofbox) > 1
        return (
            <form onSubmit={this.props.handleSubmit}>
                <h3>Please select the number of boxes you would like to order:</h3>
                <Field
                    label="Number of boxes"
                    name="numberofbox"
                    component={renderSelectField}
                    type="number"
                    onChange={reset}
                >
                    {items}
                </Field>
                {morethanonebox
                    ?
                    <div>
                        <Field
                            label="Mail the boxes to different addresses"
                            name="differentaddress"
                            component={renderCheckbox}
                            type="number"
                        />
                    </div>
                    :
                    undefined
                }
                <div className="buttoncontainer">
                    <RaisedButton disabled={numberofbox === undefined} label="Next" secondary={true} type="submit"
                                  style={{padding: "10px, 36px"}} buttonStyle={{borderRadius: "5px"}}/>
                </div>
            </form>
        )
    }
}

const renderSelectField = ({
                               input,
                               label,
                               name,
                               meta: {touched, error},
                               children,
                               ...custom
                           }) => (

    <div>
        <label>{label}</label>
        <SelectField
            errorText={touched && error}
            {...input}
            onChange={(event, index, value) => input.onChange(value)}
            children={children}
            {...custom}
            maxHeight={200}
            floatingLabelStyle={{fontFamily: "Source Sans Pro", fontSize: "20px"}}
            labelStyle={{fontFamily: "Source Sans Pro", fontSize: "20px"}}
            underlineStyle={{borderBottom:"none"}}
            style={{border:"1px solid #e4d6cf", borderRadius:"5px", backgroundColor:"#fdfdfd", paddingLeft:"10px"}}
            menuStyle={{paddingLeft:"-10px"}}
            fullWidth={true}
        />
    </div>
)

const renderCheckbox = ({input, label}) => (
    <Checkbox
        label={label}
        checked={input.value ? true : false}
        onCheck={input.onChange}
    />
)

const items = [];
for (let i = 1; i <= 20; i++) {
    items.push(<MenuItem value={i} key={i} primaryText={`${i}`}/>);
}

NumberofBox = connect(
    state => {
        const numberofbox = selector(state, 'numberofbox');
        const differentaddress = selector(state, 'differentaddress');

        return {
            numberofbox, differentaddress
        }
    }
)(NumberofBox);

export default reduxForm({
    form: 'fieldArrays', // <------ same form name
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(NumberofBox)


// WEBPACK FOOTER //
// ./src/NumberofBox.js